import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/team-management"

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/list${objToURL(values)}`);
}

export const Details  = async (id) => {
    return await axiosInstance(options).get(`${path}/${id}`);
}

export const Delete = async (id) => {
    return await axiosInstance(options).delete(`${path}/${id}`);
}
